import { Global, Collection, Jobs } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../components/SeoHead';
import MainBanner from '../../../components/MainBanner';
import LatestNews from '../../../components/LatestNews';
import AllSectors from '../../../components/AllSectors';
import ImageWithTextWithOverlay from '../../../components/ImageWithTextWithOverlay';
import SimpleFormWithBgImage from '../../../components/SimpleFormWithBgImage';
import LatestJobs from '../../../components/LatestJobs';
import LatestTestimonials from '../../../components/LatestTestimonials';

export default function JobSeekersPage({
    global,
    all_news,
    all_specialisms,
    all_jobs,
    all_candidate_testimonials
}) {
    return (
        <>
            <SeoHead
                page_name={`Job seekers | The global house of tech and transformation recruitment | Lorien | United States`}
                canonical_link={`job-seekers`}
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={`us.job_seekers_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Your Gateway to the best Tech Jobs in the US</h1>
                        <p>The tech industry is constantly evolving. Every day brings new breakthroughs with the potential to change the way we work and live – and you could be at the forefront of this progress. Whether you’re looking for a contract role or permanent position, we connect you to the companies taking tech to the next level. Discover more of the industry’s most exciting careers below.</p>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/sub-banner-job-seekers.png`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
                breadcrumb_title={`Job Seekers`}
            />
            <LatestJobs
                global={global}
                pathPrefix={`us.job_seekers_page.latest_jobs`}
                customClass={`py-5 grayGradientBg`}
                post={all_jobs}
                content={<>
                    <h2>Discover our live jobs</h2>
                    <p>Explore over 200 live opportunities and find your next exciting career move.</p>
                </>
                }
                buttonTitle={``}
                buttonLink={``}
                swiperID={`latestJobsSwiper`}
                jobSearch={true}
                locale={`https://www.lorienglobal.com/us`}

            />
            <LatestTestimonials
                global={global}
                pathPrefix={`us.job_seekers_page.latest_testimonials`}
                customClass={`py-5`}
                content={
                    <>
                        <h2>Candidate's Testimonials</h2>
                    </>
                }
                post={all_candidate_testimonials}
                swiperID={`latestTestimonialsSwiper`}
            />
            <SimpleFormWithBgImage
                global={global}
                pathPrefix={`us.job_seekers_page.simple_form_with_bg_image`}
                customClass={`py-5 position-relative`}
                formId={`d7a2aa41-06d5-4ca9-a3e1-e738a9c18985`}
                content={
                    <>
                        <h2>Join Our Talent Network</h2>
                        <p>Are you looking to take the next steps in your tech career?
                            Register your resume in the form and let our recruitment team help you.</p>
                    </>
                }
                bgImageLink={``}
                bgImageAlt={``}
                anchorID={`join-our-talent-network`}
                successPageUrl={`/us/job-seekers/subscription-success`}
            />
            <AllSectors
                global={global}
                pathPrefix={`us.job_seekers_page.all_sectors`}
                customClass={`py-5`}
                content={
                    <>
                        <h2>Specialist Markets</h2>
                        <p>As the house of global tech and transformation recruitment, we specialise in bringing talent solutions across the full digital spectrum to life. Each one of our solutions is built to the specific needs of our clients, with great variety in size, shape, and scale of design, but with a unifying core of deep tech sector expertise.</p>
                        <p>This gives our clients the unique advantage of tech specialism at scale. Naturally, our background means that we cover all digital skillsets, but there are specific sub-sectors where we provide even deeper levels of insight–often in the places where skills are niche, rare, competitive, or just developing. We call these our Specialist Markets.</p>
                    </>
                }
                post={all_specialisms}
                locale={`/us/`}
            />
            <LatestNews
                global={global}
                pathPrefix={`us.job_seekers_page.latest_news`}
                customClass={`py-5`}
                post={all_news}
                content={
                    <>
                        <h2>The Lorien Pulse: Latest News, Events, and Insights</h2>
                        <p>Our tech expertise and partner-led approach allows us to deliver highly successful results for our clients so they can attract and retain unique talent for their business. Explore our latest collection of case studies, news, events, and insights</p>
                    </>
                }
                buttonLink={`/us/insights/`}
                buttonTitle={`View All Insights`}
                locale={`us/`}
            />
            <ImageWithTextWithOverlay
                global={global}
                pathPrefix={`us.job_seekers_page.multi_column_cta`}
                customClass={`py-5`}
                content={
                    <>
                        <h2>Want to be featured as an Employer?</h2>
                    </>
                }
                buttonTitle={`Get in Touch`}
                buttonLink={`/us/contact-us/`}
                imageURL={`/site-assets/images/ask-david.jpg`}
                imageALT={`Job Seekers Featured Image`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const news = (await Collection('news'))
        .filter(function (post) {
            return (
                post.country?.en == "United States" || post.country?.en == "All"
            );
        });
    const specialisms = (await Collection('specialisms'))
        .filter(function (post) {
            return (
                post.region?.en.includes("United States")
            );
        });
    const all_jobs = (await Jobs())
        .filter(function (job) {
            return (
                job.categories
                    // Pulls Sectors only
                    .find((cat) => cat.id === "7710db30-b4cf-4029-b846-e02e2f0c9b3b" && cat.values.find((x) => x.name === "United States"))
            );
        })
        .filter(function (job) {
            return (
                (new Date(job?.expires_at)) >= (new Date())
            )
        })
        .getItems().slice(0, 8);
    const candidate_testimonials = (await Collection('candidate_testimonials'))
        .filter(function (post) {
            return (
                post.region?.en.includes("US")
            );
        });

    const all_candidate_testimonials = candidate_testimonials.orderBy('order').getItems();
    const all_specialisms = specialisms.orderBy('order').getItems();
    const all_news = news.orderBy('date').getItems().slice(0, 8);
    return {
        props: {
            global,
            all_news,
            all_specialisms,
            all_jobs,
            all_candidate_testimonials
        }
    };
}
